<!-- FAB colapsado: se oculta cuando hay un drawer abierto y no hay llamada activa;
     si hay llamada activa se mueve a la izquierda para no tapar los botones del drawer -->
@if (!isOpen && (!anyDrawerOpen || activeCall)) {
<button
  type="button"
  (click)="toggle()"
  class="fixed bottom-6 z-sticky flex items-center gap-2 rounded-full bg-brand-500 px-4 py-3 text-white shadow-lg hover:bg-brand-600 transition-all"
  [class.right-6]="!anyDrawerOpen"
  [class.left-20]="anyDrawerOpen"
  [title]="statusLabel()">
  <span class="relative flex h-3 w-3">
    <span class="absolute inline-flex h-full w-full rounded-full opacity-75" [class]="statusColor()"></span>
    <span class="relative inline-flex rounded-full h-3 w-3" [class]="statusColor()"></span>
  </span>
  <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
  </svg>
  @if (activeCall) {
    <span class="text-xs font-medium">{{ activeCall.phase === 'IN_CALL' ? elapsed : '...' }}</span>
  }
</button>
}

<!-- Panel expandido: se reposiciona a la izquierda cuando hay un drawer abierto -->
@if (isOpen) {
<div class="fixed bottom-6 z-drawer w-80 max-h-[90vh] overflow-hidden flex flex-col rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-2xl"
  [class.right-6]="!anyDrawerOpen"
  [class.left-20]="anyDrawerOpen">
  <!-- Header -->
  <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <div class="flex items-center gap-2">
      <span class="relative flex h-2.5 w-2.5">
        <span class="absolute inline-flex h-full w-full rounded-full opacity-75" [class]="statusColor()"></span>
        <span class="relative inline-flex rounded-full h-2.5 w-2.5" [class]="statusColor()"></span>
      </span>
      <span class="text-sm font-medium text-gray-900 dark:text-white">{{ statusLabel() }}</span>
    </div>
    <button
      type="button"
      (click)="close()"
      class="p-1 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800 transition-colors">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- Banners de estado / error -->
  @if (deviceState === 'NO_CONFIG') {
  <div class="px-4 py-3 bg-warning-50 border-b border-warning-200 dark:bg-warning-500/10 dark:border-warning-500/20">
    <p class="text-xs text-warning-700 dark:text-warning-400">
      El módulo de llamadas no está configurado. Pídele al administrador que complete Twilio.
    </p>
  </div>
  } @else if (deviceState === 'ERROR' && lastError) {
  <div class="px-4 py-3 bg-error-50 border-b border-error-200 dark:bg-error-500/10 dark:border-error-500/20">
    <p class="text-xs text-error-700 dark:text-error-400">{{ lastError }}</p>
  </div>
  }

  <!-- Cuerpo: cambia según haya o no llamada activa -->
  <div class="flex-1 overflow-y-auto">

    <!-- INCOMING -->
    @if (activeCall?.phase === 'INCOMING') {
    <div class="p-6 flex flex-col items-center gap-4">
      <div class="flex h-16 w-16 items-center justify-center rounded-full bg-teal-100 dark:bg-teal-500/20 animate-pulse">
        <svg class="h-8 w-8 text-teal-600 dark:text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
        </svg>
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400">Llamada entrante</p>
      <p class="text-lg font-mono font-semibold text-gray-900 dark:text-white">{{ activeCall?.from || '—' }}</p>
      <div class="flex gap-3 w-full">
        <button
          type="button"
          (click)="rechazar()"
          class="flex-1 flex items-center justify-center gap-2 rounded-xl bg-error-500 hover:bg-error-600 text-white py-3 font-medium transition-colors">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
          Rechazar
        </button>
        <button
          type="button"
          (click)="aceptar()"
          class="flex-1 flex items-center justify-center gap-2 rounded-xl bg-success-500 hover:bg-success-600 text-white py-3 font-medium transition-colors">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
          Aceptar
        </button>
      </div>
    </div>
    }

    <!-- CONNECTING -->
    @else if (activeCall?.phase === 'CONNECTING') {
    <div class="p-6 flex flex-col items-center gap-4">
      <div class="flex h-16 w-16 items-center justify-center rounded-full bg-warning-100 dark:bg-warning-500/20">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-warning-500"></div>
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400">Llamando...</p>
      <p class="text-lg font-mono font-semibold text-gray-900 dark:text-white">{{ activeCall?.to || '—' }}</p>
      <button
        type="button"
        (click)="colgar()"
        class="w-full flex items-center justify-center gap-2 rounded-xl bg-error-500 hover:bg-error-600 text-white py-3 font-medium transition-colors">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
        Cancelar
      </button>
    </div>
    }

    <!-- IN_CALL -->
    @else if (activeCall?.phase === 'IN_CALL') {

      <!-- Panel de Transfer (cubre todo el cuerpo cuando está abierto) -->
      @if (showTransferPanel) {
      <div class="p-4 space-y-3">
        <div class="flex items-center justify-between">
          <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Transferir llamada</h3>
          <button
            type="button"
            (click)="cerrarTransfer()"
            class="p-1 rounded text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Tabs AGENT/TEAM -->
        <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-600 overflow-hidden text-sm">
          <button
            type="button"
            (click)="transferType = 'AGENT'; transferTargetId = null"
            class="flex-1 px-3 py-1.5 font-medium transition-colors"
            [class]="transferType === 'AGENT' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 dark:bg-gray-800 dark:text-gray-300'">
            Agente
          </button>
          <button
            type="button"
            (click)="transferType = 'TEAM'; transferTargetId = null"
            class="flex-1 px-3 py-1.5 font-medium transition-colors border-l border-gray-200 dark:border-gray-600"
            [class]="transferType === 'TEAM' ? 'bg-brand-500 text-white' : 'bg-white text-gray-600 dark:bg-gray-800 dark:text-gray-300'">
            Team
          </button>
        </div>

        <!-- Lista de agentes disponibles (solo en modo AGENT) -->
        @if (transferType === 'AGENT') {
          @if (loadingAgents) {
          <div class="flex justify-center py-4">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
          </div>
          } @else if (agentsLoadError) {
          <p class="text-xs text-warning-600 dark:text-warning-400">{{ agentsLoadError }}. Usa el ID manualmente abajo.</p>
          } @else if (agents.length > 0) {
          <div class="max-h-40 overflow-y-auto space-y-1">
            @for (a of agents; track a.userId) {
            <button
              type="button"
              (click)="seleccionarAgente(a)"
              class="w-full flex items-center justify-between px-3 py-2 rounded-lg text-left text-sm transition-colors"
              [class]="transferTargetId === a.userId ? 'bg-brand-50 text-brand-700 border border-brand-200 dark:bg-brand-500/10 dark:text-brand-400 dark:border-brand-500/30' : 'bg-gray-50 hover:bg-gray-100 text-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-300'">
              <span>{{ a.agentName }}</span>
              <span class="text-xs text-gray-500 dark:text-gray-400" [title]="'Identificador interno: ' + a.userId">{{ a.activeCalls }}/{{ a.maxConcurrentCalls }} llamadas</span>
            </button>
            }
          </div>
          } @else {
          <p class="text-xs text-gray-500 dark:text-gray-400">No hay agentes disponibles ahora mismo.</p>
          }
        }

        <!-- Input manual de ID (siempre visible) -->
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            Identificador de destino ({{ transferTypeLabel() }})
          </label>
          <input
            type="number"
            [(ngModel)]="transferTargetId"
            placeholder="ej. 5"
            class="w-full rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-white focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20">
        </div>

        <div class="flex gap-2 pt-2">
          <button
            type="button"
            (click)="cerrarTransfer()"
            class="flex-1 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
            Cancelar
          </button>
          <button
            type="button"
            (click)="ejecutarTransfer()"
            [disabled]="transferring || transferTargetId == null"
            class="flex-1 rounded-lg bg-brand-500 hover:bg-brand-600 disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed px-3 py-2 text-sm font-medium text-white">
            {{ transferring ? 'Transfiriendo...' : 'Transferir' }}
          </button>
        </div>
      </div>
      } @else {

      <!-- Vista normal de llamada en curso -->
      <div class="p-4 flex flex-col items-center gap-4">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ activeCall?.isOnHold ? 'En espera' : 'En llamada' }}
        </p>
        <p class="text-lg font-mono font-semibold text-gray-900 dark:text-white">{{ activeCall?.to || activeCall?.from || '—' }}</p>
        <p class="text-2xl font-mono" [class]="activeCall?.isOnHold ? 'text-warning-500' : 'text-brand-600 dark:text-brand-400'">
          {{ elapsed }}
        </p>

        @if (activeCall?.isOnHold) {
        <span class="inline-flex items-center rounded-full bg-warning-50 px-2.5 py-0.5 text-xs font-medium text-warning-700 border border-warning-200 dark:bg-warning-500/10 dark:text-warning-400 dark:border-warning-500/20">
          La llamada está en espera
        </span>
        }

        <!-- Panel CRM context (Fase 5) -->
        @if (activeCall?.crmCallId) {
        <div class="w-full">
          <app-call-crm-context-panel [callId]="activeCall?.crmCallId ?? null" />
        </div>
        }

        <div class="grid grid-cols-3 gap-2 w-full">
          @for (row of dialPad; track $index) {
            @for (key of row; track key.d) {
            <button
              type="button"
              (click)="appendDigit(key.d)"
              class="rounded-xl bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 py-2 text-center transition-colors">
              <span class="text-lg font-semibold text-gray-900 dark:text-white">{{ key.d }}</span>
              @if (key.sub) {
              <p class="text-[10px] text-gray-400 dark:text-gray-500">{{ key.sub }}</p>
              }
            </button>
            }
          }
        </div>

        <div class="grid grid-cols-2 gap-2 w-full">
          <button
            type="button"
            (click)="toggleMute()"
            class="flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-medium transition-colors"
            [class]="activeCall?.muted ? 'bg-gray-700 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-300'">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"/>
            </svg>
            {{ activeCall?.muted ? 'Silenciado' : 'Mute' }}
          </button>
          <button
            type="button"
            (click)="toggleHold()"
            [disabled]="!canRoute() || holdInFlight"
            class="flex items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-medium transition-colors disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400 dark:disabled:text-gray-500 disabled:cursor-not-allowed"
            [class]="!canRoute() ? '' : (activeCall?.isOnHold ? 'bg-warning-500 hover:bg-warning-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-300')"
            [title]="!canRoute() ? 'Acción no disponible (id del CRM no resuelto)' : ''">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6"/>
            </svg>
            {{ holdInFlight ? '...' : (activeCall?.isOnHold ? 'Reanudar' : 'Hold') }}
          </button>
        </div>

        <div class="grid grid-cols-2 gap-2 w-full">
          <button
            type="button"
            (click)="abrirTransfer()"
            [disabled]="!canRoute()"
            class="flex items-center justify-center gap-2 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-300 py-2.5 text-sm font-medium transition-colors disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400 dark:disabled:text-gray-500 disabled:cursor-not-allowed"
            [title]="!canRoute() ? 'Acción no disponible (id del CRM no resuelto)' : ''">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
            </svg>
            Transferir
          </button>
          <button
            type="button"
            (click)="colgar()"
            class="flex items-center justify-center gap-2 rounded-xl bg-error-500 hover:bg-error-600 text-white py-2.5 text-sm font-medium transition-colors">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z M3 3l18 18"/>
            </svg>
            Colgar
          </button>
        </div>
      </div>
      }
    }

    <!-- IDLE: dialer manual -->
    @else {
    <div class="p-4 space-y-3">
      <div class="relative">
        <input
          type="tel"
          [(ngModel)]="toNumber"
          placeholder="+51999999999"
          class="w-full rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 px-4 py-3 pr-10 text-center font-mono text-lg text-gray-900 dark:text-white focus:border-brand-500 focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500/20 transition-all">
        @if (toNumber.length > 0) {
        <button
          type="button"
          (click)="backspace()"
          class="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          title="Borrar último">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l-7-7 7-7m4 14l-7-7 7-7"/>
          </svg>
        </button>
        }
      </div>

      <div class="grid grid-cols-3 gap-2">
        @for (row of dialPad; track $index) {
          @for (key of row; track key.d) {
          <button
            type="button"
            (click)="appendDigit(key.d)"
            class="rounded-xl bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 py-3 text-center transition-colors">
            <span class="text-xl font-semibold text-gray-900 dark:text-white">{{ key.d }}</span>
            @if (key.sub) {
            <p class="text-[10px] text-gray-400 dark:text-gray-500">{{ key.sub }}</p>
            }
          </button>
          }
        }
      </div>

      <button
        type="button"
        (click)="llamar()"
        [disabled]="initiating || !isValidNumber() || !isDeviceReady()"
        class="w-full flex items-center justify-center gap-2 rounded-xl bg-brand-500 hover:bg-brand-600 disabled:bg-gray-300 dark:disabled:bg-gray-700 disabled:cursor-not-allowed text-white py-3 font-medium transition-colors">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
        </svg>
        {{ initiating ? 'Llamando...' : 'Llamar' }}
      </button>

      @if (!isValidNumber() && toNumber.length > 0) {
      <p class="text-xs text-error-600 dark:text-error-400 text-center">
        Formato E.164 requerido (ej. +5117654321)
      </p>
      }
    </div>
    }
  </div>
</div>
}
